import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trackinglistview',
  templateUrl: './trackinglistview.component.html',
  styleUrls: ['./trackinglistview.component.css']
})
export class TrackinglistviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
